/**
 * Parse the HubSpot deal id out of a quote's `hubspot_link`.
 *
 * Deals carry a link of the shape
 *   https://app.hubspot.com/contacts/<portal>/record/0-3/<dealId>
 * where `0-3` is the deal object type. The ERP sync control sends that id to
 * PUT /:id/hubspotdeal/:hs_object_id; since ATE-11441 there is no create route
 * (Hakim 2026-10-07, ATE-2257), so a link that names no deal must parse to null
 * and the caller must refuse rather than fall back to a creation path.
 *
 * The dark AngularJS app already had this parse inline as `getHubspotObjectID()`
 * (apps/frontend/src/atek-erp/quote-form/component.js:1121-1126) and takes the last
 * non-empty path segment. That helper cannot be imported here, and its rule is too
 * loose: on a contact (`0-1`) or company (`0-2`) link it would hand a non-deal id to
 * the deals route. This one is anchored on the deal record type and returns null
 * instead, which is what makes "no id -> button disabled" enforceable.
 */
const DEAL_RECORD_PATH = /\/record\/0-3\/([A-Za-z0-9_-]+)/;

export function parseHubspotDealId(link: string | null | undefined): string | null {
  if (!link) return null;
  const match = link.trim().match(DEAL_RECORD_PATH);
  return match ? match[1] : null;
}
